<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <h3>Send SMS to All Clients</h3>
        <p class="text-muted">This will send the message to all clients who have a phone number.</p>

        <form @submit.prevent="sendBulkSms">
          <div class="form-group">
            <label>Message <span class="text-danger">*</span></label>
            <textarea
              v-model="message"
              class="form-control"
              rows="5"
              required
              placeholder="Enter your message here..."
              :maxlength="maxLength"
            ></textarea>
            <small class="text-muted">{{ message.length }} / {{ maxLength }} characters</small>
          </div>

          <div class="text-end mt-3">
            <button
              class="btn btn-primary"
              type="submit"
              :disabled="isSending || !message.trim()">
              {{ isSending ? 'Sending...' : 'Send SMS to All' }}
            </button>
            <button
              class="btn btn-secondary"
              type="button"
              @click="$emit('input', false)"
              :disabled="isSending">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean
  },
  data() {
    return {
      message: '',
      isSending: false,
      maxLength: 1000
    }
  },
  methods: {
    sendBulkSms() {
      if (!this.message.trim()) {
        Swal.fire({
          title: 'Empty Message!',
          text: 'Please enter a message.',
          icon: 'warning',
          confirmButtonColor: '#3085d6'
        })
        return
      }

      this.isSending = true

      axios.post('/clients/send-sms-all', {
        message: this.message
      })
        .then(() => {
          Swal.fire({
            title: 'Sent!',
            text: 'SMS sent to all clients successfully!',
            icon: 'success',
            confirmButtonColor: '#3085d6'
          })
          this.$emit('input', false)
          this.$emit('sent')
          this.message = ''
        })
        .catch(error => {
          console.error(error)
          const errorMessage = error.response?.data?.message || 'Error sending SMS. Please try again.'
          Swal.fire({
            title: 'Error!',
            text: errorMessage,
            icon: 'error',
            confirmButtonColor: '#3085d6'
          })
        })
        .finally(() => {
          this.isSending = false
        })
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper {
  width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
}
</style>


